import {CopyToClipboard} from "react-copy-to-clipboard";
import {toast} from "react-hot-toast";
import {FaRegCopy} from "react-icons/fa6";

import Button from "@/components/button/Button.tsx";
import {GlobalAlertState} from "@/lib/types/alerting.ts";
import {Service} from "@/lib/types/checks.ts";

type RecordCopyIDProps = {
  name: string;
  record: GlobalAlertState | Service;
};

export const RecordCopyID = ({name, record}: RecordCopyIDProps) => {
  return (
    <CopyToClipboard text={record.id.toString()} onCopy={() => toast.success("Copied to clipboard")}>
      <Button variant={"dropdownMenuItem"} className="text-nowrap">
        {name} ID: {record.id} <FaRegCopy size={16} />
      </Button>
    </CopyToClipboard>
  );
};
